import React, { Component } from "react";

import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import PreloaderLight from "./../../../shared/items/static/preloaderLight";
import { states } from "./../../../reducers/queriesStates";

import { withRestore } from "../../../shared/containers/containerRestore";

import styles from "./buttonRestorePasswordWrapper.module.scss";

class ButtonRestorePasswordWrapper extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.clickEnter);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.clickEnter);
  }

  clickEnter = (e) => {
    const { onRestorePassword, restore } = this.props;

    if (e.keyCode === 13) {
      onRestorePassword(restore.restoreItems);
    }
  };

  onRestore() {
    const { onRestorePassword, restore } = this.props;
    onRestorePassword(restore.restoreItems);
  }

  render() {
    const { restore } = this.props;

    return (
      <ButtonPrimary handleClick={this.onRestore.bind(this)}>
        {restore.dataState === states.REQUEST ? (
          <div className={styles.container_preloader}>
            <PreloaderLight />
          </div>
        ) : (
          "Восстановить"
        )}
      </ButtonPrimary>
    );
  }
}

export default withRestore(ButtonRestorePasswordWrapper);
